var _rect, _path, _rect2, _circle, _circle2, _circle3, _rect3, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 15,
    width: 42,
    height: 54,
    rx: 3,
    stroke: "#274642",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 39H61.5L63 38V26.2903V19.5L62 15.5H42H22L21 18.6129V34.871V39H42.5L51 42.5L52.5 39Z",
    fill: "#E3EDC3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 10.1149,
    rx: 4.36364,
    transform: "matrix(-1 0 0 1 50 24.7009)",
    fill: "#274642"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.83908,
    cy: 1.83908,
    r: 1.83908,
    transform: "matrix(-1 0 0 1 46.873 27.8276)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.83908,
    cy: 1.83908,
    r: 1.83908,
    transform: "matrix(-1 0 0 1 40.9883 27.8276)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.83908,
    cy: 1.83908,
    r: 1.83908,
    transform: "matrix(-1 0 0 1 43.9316 19)",
    fill: "#274642"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.47126,
    height: 2.75862,
    transform: "matrix(-1 0 0 1 42.8281 21.9424)",
    fill: "#274642"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50H52",
    stroke: "#274642",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55H46",
    stroke: "#274642",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 60L43 60.003",
    stroke: "#274642",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.45 62.5L50.75 60.75L53.05 62.5L52.2 59.65L54.5 57.8H51.65L50.75 55L49.85 57.8H47L49.3 59.65L48.45 62.5Z",
    fill: "#274642"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 39H43.2765C43.4237 39 43.5691 39.0325 43.7023 39.0952L50.3566 42.2267C51.0696 42.5622 51.8725 41.9797 51.7747 41.1978L51.6405 40.124C51.5659 39.5272 52.0313 39 52.6328 39H63",
    stroke: "#274642",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.62d5e393b7bbf7b12ed03a804fcc095d.svg";
export { ForwardRef as ReactComponent };